export { default as BulletinRecipientsScreen } from "./BulletinRecipientsScreen";
